import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { CustomerBenefitEventItem } from '@models/feed';
import { Feed } from '@models/feed';
import React, { useMemo } from 'react';
import { NavBackIcon } from '@components/common/Icons';
import { cdnImageUrl } from '@utils/image';

export const CustomerBenefitEventsPreview: React.FC<{ data: Feed<CustomerBenefitEventItem> }> = (props) => {
  const { data } = props;
  const title = data?.title;
  const events = data?.data;

  const combinedEvents = useMemo(() => {
    const sorted = [];
    const notSorted = [];

    for (const event of data?.data || []) {
      if (typeof event.order === 'number' && event.order !== 0) sorted.push(event);
      else notSorted.push(event);
    }

    sorted.sort((a, b) => a.order! - b.order!);

    return [...sorted, ...notSorted];
  }, [events]);

  return (
    <div style={{ width: '528px', height: 'calc(100vh - 140px)', backgroundColor: 'white' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <button
          className="link-button"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            height: '56px',
            minWidth: '56px',
          }}>
          <NavBackIcon color={'#242424'} />
        </button>
        <div style={{ alignSelf: 'center', fontSize: '17px', fontWeight: 'bold', color: '#242424' }}>
          {title || '이벤트 모아보기'}
        </div>
        <div style={{ width: '56px' }} />
      </div>
      <div style={{ height: '100%', width: '100%' }}>
        <OverlayScrollbarsComponent
          defer
          options={{
            scrollbars: { autoHide: 'scroll' },
            overflow: {
              x: 'hidden',
            },
          }}
          style={{ height: '100%' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', height: '100%', padding: '0 16px' }}>
            {combinedEvents.map((event: CustomerBenefitEventItem, index) => (
              <div
                key={event.id}
                style={{
                  position: 'relative',
                  width: '100%',
                  height: '110px',
                  marginTop: index === 0 ? 12 : 0,
                  marginBottom: index === combinedEvents.length - 1 ? 12 : 0,
                  padding: '20px',
                  backgroundColor: event.backgroundColor || '#ffffff',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  cursor: 'pointer',
                }}>
                <img
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: '200px',
                    height: '110px',
                    objectFit: 'cover',
                  }}
                  src={event.imageUrlTemp || cdnImageUrl(event.imageUrl)}
                  alt={event.title}
                />
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <div
                    style={{
                      color: '#242424',
                      fontSize: '18px',
                      fontWeight: 700,
                      wordWrap: 'break-word',
                      whiteSpace: 'pre-wrap',
                    }}>
                    {event.title}
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ color: event.subTitleColor || '#242424', fontSize: '13px', fontWeight: 600 }}>
                      {event.subtitle}
                    </div>
                    <div style={{ color: event.subTitleColor || '#242424', fontSize: '13px', fontWeight: 600 }}>
                      {'>'}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </OverlayScrollbarsComponent>
      </div>
    </div>
  );
};
